module.exports = __webpack_public_path__ + "img/147ne.f50d7fe2.svg";